import type { ConditionAndServiceFormValues } from "./types/ConditionAndServiceFormValues"

type FieldName = keyof ConditionAndServiceFormValues

// Condition
const firstRegistrationDateName: FieldName = "firstRegistrationDate"
const formerRentalCarName: FieldName = "formerRentalCar"
const mileageName: FieldName = "mileage"
const nextGeneralInspectionDateName: FieldName = "nextGeneralInspectionDate"
const nonSmokerName: FieldName = "nonSmoker"
const previousDamageName: FieldName = "previousDamage"
const previousDamageAmountName: FieldName = "previousDamageAmount"
const previousDamageDescriptionName: FieldName = "previousDamageDescription"
const previousOwnersName: FieldName = "previousOwners"
const previousOwnerUsageHistoryName: FieldName = "previousOwnerUsageHistory"
const renewGeneralInspectionOnSaleName: FieldName = "renewGeneralInspectionOnSale"

// CarPass
const carPassUrlName: FieldName = "carPassUrl"

// Battery information
const batteryCapacityPercentageName: FieldName = "batteryCapacityPercentage"
const batteryCapacityDateName: FieldName = "batteryCapacityDate"
const batteryCapacityMileageName: FieldName = "batteryCapacityMileage"

const accidentDescriptionName: FieldName = "accidentDescription"
const accidentFreeName: FieldName = "accidentFree"

const fullServiceHistoryName: FieldName = "fullServiceHistory"
const fullServiceHistoryInPorscheCenterName: FieldName = "fullServiceHistoryInPorscheCenter"

const latestMaintenanceDateName: FieldName = "latestMaintenanceDate"
const latestMaintenanceMileageName: FieldName = "latestMaintenanceMileage"
const latestMaintenanceScopeName: FieldName = "latestMaintenanceScope"
const latestMaintenanceWorkshopName: FieldName = "latestMaintenanceWorkshop"

const reconditionedName: FieldName = "reconditioned"
const reconditioningAmountName: FieldName = "reconditioningAmount"
const reconditioningApproximateAmountName: FieldName = "reconditioningApproximateAmount"

export const conditionAndServiceFieldNames = {
	accidentDescriptionName,
	accidentFreeName,
	batteryCapacityDateName,
	batteryCapacityMileageName,
	batteryCapacityPercentageName,
	carPassUrlName,
	firstRegistrationDateName,
	formerRentalCarName,
	fullServiceHistoryInPorscheCenterName,
	fullServiceHistoryName,
	latestMaintenanceDateName,
	latestMaintenanceMileageName,
	latestMaintenanceScopeName,
	latestMaintenanceWorkshopName,
	mileageName,
	nextGeneralInspectionDateName,
	nonSmokerName,
	previousDamageAmountName,
	previousDamageDescriptionName,
	previousDamageName,
	previousOwnersName,
	previousOwnerUsageHistoryName,
	reconditionedName,
	reconditioningAmountName,
	reconditioningApproximateAmountName,
	renewGeneralInspectionOnSaleName,
}
